import React, { useEffect, useLayoutEffect } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import _ from "lodash";
import classNames from "classnames";
import style from "../../assets/scss/components/ui-element/modal.module.scss";
import { ReactComponent as TimesIcon } from "../../assets/icons/times.svg";

// Tracks how many modals are currently open so we only restore scroll when the last one closes.
let openModalCount = 0;

function Modal({ open, onClose, children, wrapperClassName, boxClassName, showCrossIcon = true }) {
  useLayoutEffect(() => {
    if (!open) return;

    openModalCount++;
    document.body.style.overflow = "hidden";

    return () => {
      openModalCount--;
      if (openModalCount === 0) {
        document.body.style.overflow = null;
      }
    };
  }, [open]);

  useEffect(() => {
    const closeModal = e => {
      if (!_.isFunction(onClose)) return;

      if (e.key === "Escape") {
        onClose();
      }
    };

    if (open) {
      document.addEventListener("keyup", closeModal);
    }

    return () => document.removeEventListener("keyup", closeModal);
  }, [open, onClose]);

  if (!open) return null;

  const preventReactRouterInheritance = e => e.stopPropagation();

  return ReactDOM.createPortal(
    <div
      className={classNames(style["modal"], wrapperClassName)}
      onClick={preventReactRouterInheritance}
    >
      <div className={classNames(style["modal__box"], boxClassName)}>
        {showCrossIcon ? (
          <TimesIcon className={style["modal__box__close-button"]} onClick={onClose} />
        ) : null}
        {children}
      </div>
    </div>,
    document.getElementById("root")
  );
}

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func
};

export default Modal;